import model from 'modules/routePacking/routeModel';

const { fields } = model;

export default [
  fields.name,
  fields.ebox,
];
